import { dataProps, subItemProps, qualityItemProps } from './properties'

export const setItemCategoryList = (state, payload) => {
    state.list = payload
}    

export const setItemCategoryList_Fabric = (state, payload) => {
    state.fabric_list = payload
}    


export const setAllItemCategoryList = (state, payload) => {
    state.all_list = payload
}    

export const setItemCategoryData = (state, payload) => {
    state.props = payload.response
    
    if(state.props.sub_item_list.length === 0) {
        state.props.sub_item_list = [JSON.parse(JSON.stringify(subItemProps))]
    } else if(payload.copy) {
        state.props.sub_item_list.forEach(element => {
            element.id = 0
        })
    }

    if(state.props.quality_point_list.length === 0) {
        state.props.quality_point_list = [JSON.parse(JSON.stringify(qualityItemProps))]
    } else if(payload.copy) {
        state.props.quality_point_list.forEach(element => {
            element.id = 0
        })
    }

    let key = 0
    state.props.sub_item_list.forEach(element => {
        element.key = key
        key ++
    })

    key = 0
    state.props.quality_point_list.forEach(element => {
        element.key = key
        key ++
    })

} 

export const addNewSubCategoryItemRow = state => {

    let key = 0
    state.props.sub_item_list.push(JSON.parse(JSON.stringify(subItemProps)))

    state.props.sub_item_list.forEach(element => {
        element.key = key
        key ++
    })

    setTimeout(() => {
        document.getElementById('sub_category_name_'+(key-1)).focus()
    }, 300);

}

export const removeSubCategoryItemRow = (state, payload) => {

    let key = 0

    state.props.deleted_sub_item_list_items.push(state.props.sub_item_list[payload])

    state.props.sub_item_list.splice(payload, 1)

    if(state.props.sub_item_list.length === 0) {
        state.props.sub_item_list = [JSON.parse(JSON.stringify(subItemProps))]
    }

    state.props.sub_item_list.forEach(element => {
        element.key = key
        key ++
    })

}


export const addNewQualityPointItemRow = state => {

    let key = 0
    state.props.quality_point_list.push(JSON.parse(JSON.stringify(qualityItemProps)))

    state.props.quality_point_list.forEach(element => {
        element.key = key
        key ++
    })

    setTimeout(() => {
        document.getElementById('quality_point_'+(key-1)).focus()
    }, 300);

}

export const removeQualityPointItemRow = (state, payload) => {

    let key = 0

    state.props.deleted_quality_point_list_items.push(state.props.quality_point_list[payload])

    state.props.quality_point_list.splice(payload, 1)

    if(state.props.quality_point_list.length === 0) {
        state.props.quality_point_list = [JSON.parse(JSON.stringify(qualityItemProps))]
    }

    state.props.quality_point_list.forEach(element => {
        element.key = key
        key ++
    })

}

export const resetItemCategoryData = state => {
    state.props = JSON.parse(JSON.stringify(dataProps))
}


// WEBPACK FOOTER //
// ./src/store/modules/itemCategory/mutations.js